import * as React from 'react';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { FileSystemListDataService } from 'src/app/general/document-generation/file-system-list.data';
import { ContextService } from 'src/core/services/context.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { VersionDocumentListView } from './version-document-list.view';


interface IVersionDocumentListControllerProps {
    contextService?: ContextService;
    downloadDocument: (fileSystemId: IFileSystemSummary) => void;
    fileName: string;
    regenerateDocument: (fileSystem: IFileSystemSummary) => Promise<void>;
    setBusy: (isBusy: boolean) => void;
}

@observer
export class VersionDocumentListController extends React.Component<IVersionDocumentListControllerProps, any> {
    @resolve
    private toast: ToastNotifications;

    @observable
    dataService: FileSystemListDataService;

    constructor(props: IVersionDocumentListControllerProps) {
        super(props);
    }

    private async loadData(): Promise<void> {
        this.dataService = FileSystemListDataService.make(this.props.contextService);

        this.dataService.addFilter('filename', 'eq', this.props.fileName);
        this.dataService.addFilter('isLatestVersion', 'eq', false);
        this.dataService.addSorting('id', 'asc', true);
        this.dataService.pageSize = 25;

        await this.dataService.load(query => query);
    }

    componentDidMount() {
        this.props.setBusy(true);

        this.loadData()
            .catch((error) => {
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            })
            .then(() => {
                this.props.setBusy(false);
            })
    }

    render() {
        if (this.dataService == null) {
            return null;
        }

        return (
            <VersionDocumentListView
                model={this.dataService}
                downloadDocument={this.props.downloadDocument}
                regenerateDocument={this.props.regenerateDocument}
                setBusy={this.props.setBusy}
            />
        );
    }
}





// WEBPACK FOOTER //
// ./src/app/general/document-generation/parts/version-document-list.controller.tsx